export const AppRoute = {
  Home: "/",
  Tour: "/tour/:tourId",
  Poi: "/tour/:tourId/poi/:poiId",
  Credits: "/credits",
};